export default __webpack_public_path__ + "static/media/marcos-zuazaga-2.c3cc9203.webp";